module.exports = __webpack_public_path__ + "static/media/filter-sidebar-close.5f23b454.svg";